import { FC, useState } from 'react';
import { PesMaxCapacityCell, PesRuntimeLoadCell, PesRuntimeField, PesRuntimeHeadingCell } from '@pes-ui/components-react';
import Cell from './Cell';
import cn from 'classnames';
import styles from './index.module.scss';
import { ComparatorRuntimeInfo } from '@pes-ui/utils/lib/types/comparator';

type Props = {
    runtimeInfo: ComparatorRuntimeInfo;
    productsId: string[];
    isHorizontalScroll: boolean;
    toggleState: boolean;
}
const RunTimeWidget: FC<Props> = (props) => {
    const [runTimeInput, setRunTimeInput] = useState('');

    const handleInput = (event) => {
        setRunTimeInput(event.detail);
    }

    const defaultMaxValue = (items: string[] ): number => {
        const maxValues = items.reduce((maxValue, item) => {
            if (runtimeInfo?.items[item]?.maxPower) {
                maxValue.push(runtimeInfo.items[item].maxPower);
            }
            return maxValue;
        }, []);
        return Math.min(...maxValues);
    }

    const defaultMinValue = (items: string[] ): number => {
        const minValues = items.reduce((minValue, item) => {
            if (runtimeInfo?.items[item]?.startPoint) {
                minValue.push(runtimeInfo.items[item].startPoint)
            }
            if (runtimeInfo?.items[item]?.maxPower) {
                minValue.push(Math.ceil(runtimeInfo?.items[item]?.maxPower * 0.1))
            }
            return minValue;
        }, []);
        return Math.max(...minValues);
    }

    const { productsId, runtimeInfo, isHorizontalScroll, toggleState } = props;

    return (
            <div className={cn({
                [styles.isShown]: !toggleState,
            })}>
                <div className="row flex-row flex-nowrap no-gutters">
                    <Cell labelCol isHorizontalScroll={isHorizontalScroll}>
                        <PesRuntimeField
                            onPesRuntimeDidSubmit={handleInput}
                            labels={runtimeInfo.translations}
                            max={defaultMaxValue(productsId)}
                            min={defaultMinValue(productsId)}
                            isError={Number(runTimeInput) > defaultMaxValue(productsId)}
                        />
                    </Cell>
                    {productsId.map((product, index) => {
                        return (
                            runtimeInfo?.items[product] ?
                            <Cell>
                                <PesRuntimeLoadCell
                                    labels={runtimeInfo.translations}
                                    runtimeParams={runtimeInfo.items[product]}
                                    value={runTimeInput}
                                />
                            </Cell>
                            : 
                            <Cell key={`${product}-${index}`}/>
                        );
                    })}
                </div> 
                <div className="row flex-row flex-nowrap no-gutters">
                    <Cell labelCol isHorizontalScroll={isHorizontalScroll}>
                        <PesRuntimeHeadingCell tooltipText={runtimeInfo?.translations?.indicatesCapacity}>
                            {runtimeInfo.translations.maxCapacityUsed}
                        </PesRuntimeHeadingCell>
                    </Cell>
                    {productsId.map((product, index) => {
                        return (
                            runtimeInfo.items[product] ?
                            <Cell>
                                <PesMaxCapacityCell
                                    labels={runtimeInfo.translations}
                                    runtimeParams={runtimeInfo.items[product]}
                                    value={runTimeInput}
                                    style={{width: '100%'}}
                                />
                            </Cell>
                            : 
                            <Cell key={`${product}-${index}`}/>
                        );
                    })}
                </div>
            </div>
    )
}
export default RunTimeWidget;